<template>
    <div class='container'>
        <div class="title">预约排期：</div>
        <div class="select-list">
            <div class="select flc" @click="select('selectYear')">
                <div>{{time2.year?time2.year + '年':'请选择年份'}}</div>
                <img src="@/assets/images/user/talk/select.png" alt="">
            </div>
            <div class="select flc" @click="select('selectMonth')">
                <div>{{time2.month?time2.month + '月':'请选择月份'}}</div>
                <img src="@/assets/images/user/talk/select.png" alt="">
            </div>
        </div>
        <div class="selectDay">
            <div class="top">
                <div class="flc">一</div>
                <div class="flc">二</div>
                <div class="flc">三</div>
                <div class="flc">四</div>
                <div class="flc">五</div>
                <div class="flc">六</div>
                <div class="flc">日</div>
            </div>
        </div>
        <div class="date">
            <div class="date-list">
                <transition-group name="fade-transition" mode="out-in">
                    <div class="date-item" v-for="item in dayList2" :key="item[0].id" >
                        <div class="date-time flc2" :class="[{'activeTime':item2.id == time2.day}]"  v-for="item2 in item" :key="item2.id" @click="timeClick(item2.name)">
                            <span :class="{'pastTime':PastTime(time2.year,time2.month,item2.name)}">{{item2.name}}</span>
                            <div v-if="ProjectTime.findIndex(i=>i.d ==item2.name)!=-1" class="status" :class="statusColor(item2.name)"></div>
                        </div>
                    </div>
                </transition-group>
            </div>
            <div class="imgbox " >
                <img @click="Bdown = !Bdown"  :class="Bdown?'rotate':'rotate2'" src="@/assets/images/user/talk/select.png" alt="">
                <div @click="Bdown = !Bdown">点击,可查看更多信息</div>
            </div>
        </div>
        <van-popup class="date-select-pop" v-model="BpopupShow" position="bottom">
            <van-picker title="请选择" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="BpopupShow = false" />
        </van-popup>
    </div>
</template>
<script>
export default {
    name: 'selecttime',
    data () {
        return {
            time:{
                year:'',
                month:'',
                currentDay:''
            },//这个是今天的日期
            time2:{
                year:'',
                month:'',
                day:''
            },//这个是选中的年月
            BpopupShow:false,//控制弹窗
            dayList:[], //这个是当前月份的数组
            columns:[],//picker需要的数组
            selectType:'',//选择的是年还是月
            Bdown:true,//这个是控制日历收起还是展开，默认收起，展示第一排
        }
    },
    props:{
        new_srv_projectmgnid:{
            type:String,
            default:''
        },
        markDate:{
            type:String,
            default:'2022-05-03'
        }
    },
    computed :{
        // 判断日期颜色
        statusColor (day) {
            let _that = this
            if (_that.ProjectTime.length == 0) {
                return
            }
            return (day) => {
                let index = _that.ProjectTime.findIndex(i=>i.d == day)
                // 这个是用来获取对应天数的state
                let obj = _that.ProjectTime[index]
                let { year,month } = this.time2
                let { year:year2,month:month2,currentDay } = this.time
                month = month <10 ?'0' + month : month
                month2 = month2 <10 ?'0' + month2 : month2
                day = day < 10 ? '0' + day : day
                currentDay = currentDay < 10 ? '0' + currentDay : currentDay
                let showDate = `${year}-${month}-${day}`
                let currentDate = `${year2}-${month2}-${currentDay}`
                // 过去时间，存在已预约、已邀请、已回执状态的展示红色；只存在已体验状态时展示绿色
                // 非过去时间，存在已预约、已邀请、已回执展示蓝色；只存在已体验状态时展示绿色
                // 均不包含已取消状态

                // 比较时间
                if (showDate < currentDate) {
                    return {
                        'status-red':obj.state !=4 && obj.state != 0,
                        'status-green':obj.state == 4
                    }
                } else if (showDate >= currentDate) {
                    return {
                        'status-blue':obj.state !=4 && obj.state != 0,
                        'status-green':obj.state == 4
                    }
                }
            }
        },
        // 获取当月时间状态
        ProjectTime () {
            let ProjectTime = this.$store.state.userTalkAppointV2.ProjectTime
            return ProjectTime.filter(i => i.state != 0)
        },
        // 是否是过去时间,
        // 如果当前年 > 参数年，一定是过去时间
        // 如果当前年 == 参数年，并且当前月 > 参数月 ，一定是过去时间
        // 如果当前年 == 参数年，并且当前月 == 参数月，并且当前日 > 参数日一定是过去时间
        // 其他情况都不是过去时间
        PastTime (year,month,day) {
            return (year,month,day) => {
                if (this.time.year > year ){
                    return true
                } else if (this.time.year == year && this.time.month > month) {
                    return true
                } else if (this.time.year == year && this.time.month == month && this.time.currentDay > day) {
                    return true
                } else {
                    return false
                }
            }
        },
        // 用来展示一行还是所有的时间
        dayList2 () {
            if (this.Bdown) {
                // 获取到当前日数
                // 去找到这个日期在当前月中是在第几排
                // 如果只展示一排，那就只展示找到的这一排
                let date = new Date()
                let days = date.getDate()
                let index = this.dayList.findIndex(item => {
                    return item.findIndex(item2 => {
                        return item2.name == days
                    }) != -1
                })
                return this.dayList.slice(index,index+1)
            } else {
                return this.dayList
            }
        }
    },
    created(){
        let date = new Date()
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let currentDay = date.getDate();
        this.time = {
            year,month,currentDay
        }
        this.time2 = {
            year,month,day:currentDay
        }
        console.log(this.time2,'im2');
        // 设置默认选中今天的时间
        this.getMonthDay(year,month)
    },
    watch:{
        // 每次这个值得改变就意味着选择的体验间已经做了改变
        markDate(newValue,oldValue){
            this.time2 = {
                year:this.time.year,month:this.time.month,day:this.time.currentDay
            }
        },
        time2:{
            handler(newValue,oldValue) {
                let year = this.time2.year
                let month = this.time2.month
                let day = this.time2.day
                month = month >= 10 ? month:'0' + month
                day = day >= 10 ? day:'0' + day
                let time = year + '-' + month + '-' + day
                this.$store.dispatch({type:'userTalkAppointV2/getReportTimeData',experience_id:this.new_srv_projectmgnid,date:time})
                // 获取日历上每天的状态
                this.getProjectCheckList()
                this.$emit('changeTime',newValue)
            },
            deep:true
        },
        new_srv_projectmgnid(newValue,oldValue){
            let year = this.time2.year
            let month = this.time2.month
            let day = this.time2.day
            month = month >= 10 ? month:'0' + month
            day = day >= 10 ? day:'0' + day
            let time = year + '-' + month + '-' + day
            this.$store.dispatch({type:'userTalkAppointV2/getReportTimeData',experience_id:this.new_srv_projectmgnid,date:time})
            // 获取日历上每天的状态
            this.getProjectCheckList()
        }
    },
    methods :{
        timeClick (day) {
            if (this.new_srv_projectmgnid == '') {
                this.$toast('请先选择体验间')
                return
            }
            if (!this.time2.year) {
                this.$toast('请选择年份')
                return
            }
            if (!this.time2.month) {
                this.$toast('请选择月份')
                return
            }
            // 因为如果点击的是空的，那么这个的name就会是空
            if (day) {
                this.$set(this.time2,'day',day)
            }
        },
        // 获取周期性时间状态
        getProjectCheckList () {
            let days = new Date(this.time2.year, this.time2.month, 0).getDate()
            let month2 = this.time2.month
            month2 = month2 >= 10 ? month2:'0' + month2
            // 获取周期性时间状态
            this.$store.dispatch({
                type:'userTalkAppointV2/getProjectTime',
                experience_id:this.new_srv_projectmgnid,
                start_at:`${this.time2.year}-${month2}-01`,
                end_at:`${this.time2.year}-${month2}-${days}`,
            })
        },
        // 选择时间
        onConfirm (selected) {
            if (this.selectType == 'selectYear') {
                this.$set(this.time2,'year',selected)
                this.$set(this.time2,'month','')
            } else if (this.selectType == 'selectMonth') {
                this.$set(this.time2,'month',selected)
            }
            this.BpopupShow = false
            this.getMonthDay(this.time2.year,this.time2.month)
        },
        select (type) {
            if (this.new_srv_projectmgnid == '') {
                this.$toast('请先选择体验间')
                return
            }
            this.selectType = type
            // this.$emit(type)
            if (type == 'selectYear') {
                let list = []
                // 获取今年的年份
                let date = new Date()
                const year = date.getFullYear()
                for (let year2 = this.markDate.split('-')[0]; year2 <= year; year2++) {
                    list.push(year2)
                }
                list.push(year + 1)
                list.push(year + 2)
                list.push(year + 3)
                this.columns = list
            } else if (type == 'selectMonth') {
                let list = [1,2,3,4,5,6,7,8,9,10,11,12]
                // 禁止用户选择体验间最初数据时间
                if (this.time2.year == this.markDate.split('-')[0]) {
                    list.splice(0,this.markDate.split('-')[1] - 1)
                }
                this.columns = list
            }
            this.BpopupShow = true
        },
        // 获取当前月有多少天
        getMonthDay (year,month) {
            // console.log(year,month,'time');
            let days = new Date(year, month, 0).getDate()
            // console.log(days,'days');
            let dayList = []
            // 这里是制作一个当前月份的数据表
            for (let index = 0; index < days; index++) {
                const obj = {
                    name: index + 1,
                    id:index + 1 //这个id是为了用来当做key、
                }
                dayList.push(obj)
            }
            // 这里是查看这个月的第一天周几
            // 例如如果是周一，那就不修改，如果是周二就在数组里面添加2个空的对象用来占位，但是获取周几如果是周日，他会返回0，所以单独判断
            let month0 = month >= 10 ?month:'0' + month
            let thisTime = `${year}-${month0}-01`;
            thisTime = thisTime.replace(/-/g, '/');
            let time = new Date(thisTime);
            let week = time.getDay(); // 星期
            // console.log(week,'week');
            if (week == 0) {
                // 这个id是为了用来当做key的
                dayList.unshift({name:'',id:10},{name:'',id:11},{name:'',id:1111},{name:'',id:11111},{name:'',id:111111},{name:'',id:1111111})
            } else {
                for (let index = 0; index < week - 1; index++) {
                    // 这个id是为了用来当做key的,防止id重复
                    dayList.unshift({name:'',id:index + 1112})
                }
            }
            // 这个循环是直接去将数组修改好
            // List是将会是这种格式[[],[],[],[]],里面每个数组都有7个数据，除了最后一个
            let List = []
            let List2 = []
            for (let index = 0; index < dayList.length; index++) {
                List2.push(dayList[index])
                if (List2.length % 7 == 0) {
                    List.push(List2)
                    List2 = []
                }
                if (index == dayList.length - 1 && List2.length != 0 ) {
                    let length =  List2.length
                    for (let i = 0; i < ( 7 - length); i++) {
                        List2.push({name:''})
                    }
                    List.push(List2)
                }
            }
            this.dayList = List
        },
    }
}
</script>
<style lang='scss' scoped>
.fade-transition-enter-active,
.fade-transition-leave-active {
    transition:all 0.3s;
}
.fade-transition-enter {
    opacity:0;
    transform:translateY(-30px);
}
.fade-transition-leave-to {
    opacity:0;
    transform:translateY(-30px);
}
.flc2 {
    display: flex;
    justify-content: center;
}
.flc {
    display: flex;
    justify-content: center;
    align-items: center;
}
.positionc {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
}
.rotate {
    transform: rotate(180deg);
    transition: all 0.3s;
}
.rotate2 {
    transform: rotate(0deg);
    transition: all 0.3s;
}
.container {
    width: 100%;
    height: 100%;
    .title {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #444444;
        margin-bottom: 16px;
    }
    .select-list {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        .select {
            position: relative;
            width: 306px;
            height: 80px;
            border-radius: 12px;
            border: 2px solid #DBDBDB;
            display: flex;
            align-items: center;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #444444;
            img {
                width: 32px;
                height: 32px;
                position: absolute;
                right: 28px;
            }
            &:nth-child(1) {
                margin-right: 22px;
            }
        }
    }
    .selectDay {
        margin-top: 12px;
        border-bottom: rgba(129, 140, 150,0.2) solid 2px;
        .top {
            display: flex;
            justify-content: space-between;
            div{
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                padding: 16px 0 20px;
                color: #B0B0B0;
                width: 34px;
            }
        }
    }
    .date {
        margin-top:12px;
        .date-list{
            // margin-bottom:12px;
            .date-item {
                width: 100%;
                height: 68px;
                display: flex;
                justify-content: space-between;

                .pastTime {
                    color:#B0B0B0;
                }
                .date-time {
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #444444;
                    width: 38px;
                    height: 68px;
                    position: relative;
                    padding-top:5px;
                    .status {
                        position: absolute;
                        width: 12px;
                        height: 12px;
                        bottom:  10px;
                        border-radius: 50%;
                    }
                    .status-green {
                        background: #318544;
                    }
                    .status-blue {
                        background: #6476DD;
                    }
                    .status-red {
                        background: #DD6464;
                    }
                }

                .activeTime{
                    background: #F1F1F1;
                    border-radius: 8px;
                }
            }
        }
        .imgbox {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            border-bottom: rgba(129, 140, 150,0.2) solid 2px;
            width: 100%;
            padding-bottom: 16px;
            img {
                width: 32px;
                height: 32px;
            }
            color: rgb(129, 140, 150);
        }
    }
}
</style>
